export const ReportIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4 15H3C3.55228 15 4 15.4477 4 16V21M4 15H18.618C19.6738 15 20.3541 13.8812 19.8732 12.9221L18.4116 10.0069C18.176 9.53696 18.176 8.97968 18.4116 8.50978L19.8732 5.59458C20.3541 4.63548 19.6738 3.51672 18.618 3.51672H5C4.44772 3.51672 4 3.96444 4 4.51672V15Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
